import { Quill } from 'react-quill';
const Inline = Quill.import('blots/inline');

class CustomAnchorBlot extends Inline {
  static create(value) {
    let node = super.create();
    if (value.href) {
      node.setAttribute('href', value.href);
    }
    if (value.style) {
      node.setAttribute('style', value.style);
    }
    return node;
  }

  static formats(node) {
    return {
      href: node.getAttribute('href'),
      style: node.getAttribute('style'),
    };
  }

  format(name, value) {
    if (name === 'customAnchor' && value) {
      if (value.href) {
        this.domNode.setAttribute('href', value.href);
      }
      if (value.style) {
        this.domNode.setAttribute('style', value.style);
      }
    } else {
      super.format(name, value);
    }
  }
}

CustomAnchorBlot.blotName = 'customAnchor';
CustomAnchorBlot.tagName = 'a';

export const CustomAnchor = CustomAnchorBlot;
